import { render } from "./LMSCoursesPage.vue?vue&type=template&id=2a4c56bd&ts=true"
import script from "./LMSCoursesPage.vue?vue&type=script&lang=ts"
export * from "./LMSCoursesPage.vue?vue&type=script&lang=ts"

import "./LMSCoursesPage.vue?vue&type=style&index=0&id=2a4c56bd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__